import { render, staticRenderFns } from "./GeneXpert.vue?vue&type=template&id=52a79b86&scoped=true"
import script from "./GeneXpert.vue?vue&type=script&lang=js"
export * from "./GeneXpert.vue?vue&type=script&lang=js"
import style0 from "./GeneXpert.vue?vue&type=style&index=0&id=52a79b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a79b86",
  null
  
)

export default component.exports